module.exports = __webpack_public_path__ + "img/managerial_tactical.77508bf0.svg";